<div class="ion-page modal-body fixed" scrollY="true">
  <div class="modalInnerWrapper modal-content">
    <div class="modal-body">
      <h4 class="t-h4 mt-4 t-medium">{{ 'MODALS.LOGIN.TITLE' | translate }}</h4>
      <form form [formGroup]="loginForm" class="text-left mt-4">
        <div class="mb-3" *ngIf="!is_registered">
          <label for="login_username" class="form-label">{{ 'MODALS.LOGIN.EMAIL' | translate }}</label>
          <input type="email" id="login_username" [(ngModel)]="loginEmail" formControlName="lEmail" class="form-control"
            placeholder="{{'PLACEHOLDERS.EMAIL' | translate}}" required />
          <span class="text-danger error " *ngIf="errorControl.lEmail.errors?.required">
            {{'FORM_ERR.EMAIL_REQ' | translate}} 
          </span>
          <span class="text-danger error " *ngIf="errorControl.lEmail.errors?.pattern">
            {{'FORM_ERR.EMAIL_INV' | translate}}
          </span>
        </div>
        <div class="mb-4">
          <label for="login_password" class="form-label">{{ 'MODALS.LOGIN.PASSWORD' | translate }}</label>
          <input type="password" inputmode="numeric" id="login_password" [(ngModel)]="loginPassword" formControlName="lPassword"
            class="form-control" placeholder="{{'MODALS.LOGIN.PW_PLACEHOLDER' | translate}}" required />
          <span class="text-danger error " *ngIf="errorControl.lPassword.errors?.required">
            {{'FORM_ERR.PIN_REQ' | translate}}
          </span>
        </div>
        <div class="mb-4">
          <a class="active" (click)="resetPassword()">{{ 'MODALS.LOGIN.FORGOT_PW' | translate }}</a>
        </div>
        <button class="btn btn-primary btn-block" (click)="login()"
          [disabled]="errorControl.lPassword.errors"
          type="buttons">{{ 'MODALS.LOGIN.LOGIN' | translate }}</button>

        <div class="mt-4">
          <button (click)="newAccount()" *ngIf="!is_registered"
            class="btn btn-secondary btn-block">{{ 'MODALS.LOGIN.NEW_ACCOUNT' | translate }}
          </button>
        </div>
      </form>
    </div>
    <!-- <ion-icon class="close icon icon-close" (click)="dismiss()" name="close-sharp"></ion-icon> -->
    <button (click)="dismiss()" type="link" class="close">
      <span class="icon icon-close"></span>
    </button>
    
  </div>
</div>